<template>
	<div :flex="flex ? flex : null" class="to-breadcrumb" :class="[`mode-${mode}`]">
		<slot></slot>
	</div>
</template>

<script lang="ts">
import { defineComponent, provide, computed } from 'vue'
import { breadcrumbProps } from './breadcrumb'

export default defineComponent({
	name: 'ToBreadcrumb',
	props: breadcrumbProps,
	setup(props) {
		const breadcrumbData = computed(() => ({
			separator: props.separator,
			separatorIcon: props.separatorIcon
		}))

		provide('breadcrumb', breadcrumbData)

		return {}
	}
})
</script>
